__turbopack_context__.v({
  "component": "style-module-scss-module__zhEleG__component",
  "round": "style-module-scss-module__zhEleG__round",
});
